<template>
  <div class="cp-backoffice-contact-view bg-grey">
    <div class="cp-backoffice-contact-view-breadcrumbs-container">
      <Breadcrumbs />
    </div>
    <div class="cp-backoffice-contact-view-section bg-white">
      <Contact
        :logo="company.logo_image"
        :logo-white="company.logo_image_white"
        :company-name="company.company_name_localized"
        :address="contact.address_localized"
        :email="contact.email"
        :telephone="contact.phone_number"
        :line="contact.line_id"
      />
    </div>
    <div>
      <b-button
          class="cp-backoffice-contact-view-create-button"
          type="is-warning"
          rounded
          @click="goToEditContact"
          >{{ $t('backoffice.contact.edit.button') }}</b-button
        >
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/backoffice/Breadcrumbs.vue';
import Contact from '@/components/Contact.vue';
import { getContact } from '@/apis/contact';
import { getCompany } from '@/apis/company';

export default {
  name: 'ContactView',
  components: {
    Breadcrumbs,
    Contact,
  },
  data() {
    return {
      contact: {},
      company: {},
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    goToEditContact() {
      this.$router.push({
        name: 'BackofficeContactEdit',
      });
    },
    async fetchData() {
      const loading = this.$buefy.loading.open();

      try {
        const contact = await getContact();
        this.contact = contact;

        const company = await getCompany();
        this.company = company;
      } finally {
        loading.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.bg-grey{
  background-color: #f2f2f2;
}
.bg-white{
  background-color: white;
}
.cp-backoffice-contact-view {
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 20px;
  &-section {
    border: 1px solid #cacaca;
    padding: 40px;
  }

  &-breadcrumbs-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  &-edit-button {
    width: 100px;
  }

  &-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
